import { reactive } from 'vue'
import { getPortalOverview } from './tenantPortal'

// Estado compartido del portal del inquilino: parque, secciones habilitadas y el contrato
// seleccionado (un inquilino con varias naves/contratos elige cuál consultar).
const state = reactive({
  overview: null,
  loading: false,
  error: '',
  selectedContractId: null,
})

let pending = null

async function loadOverview(force = false) {
  if (state.overview && !force) return state.overview
  if (pending) return pending
  state.loading = true
  state.error = ''
  pending = getPortalOverview()
    .then((overview) => {
      state.overview = overview
      const stillValid = overview.contracts.some((c) => c.id === state.selectedContractId)
      if (!stillValid) {
        // Por defecto, el primer contrato vigente; si no hay, el primero de la lista.
        const preferred = overview.contracts.find((c) => c.status === 'ACTIVE') || overview.contracts[0]
        state.selectedContractId = preferred ? preferred.id : null
      }
      return overview
    })
    .catch((err) => {
      state.error = err.message === 'PORTAL_DISABLED' ? 'PORTAL_DISABLED' : 'LOAD_FAILED'
      throw err
    })
    .finally(() => {
      state.loading = false
      pending = null
    })
  return pending
}

function selectContract(id) {
  state.selectedContractId = id
}

function resetTenantPortal() {
  state.overview = null
  state.error = ''
  state.selectedContractId = null
}

export function useTenantPortalStore() {
  return { state, loadOverview, selectContract, resetTenantPortal }
}